'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoProductLinks = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _go = require('constants/go');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoProductLinks = exports.GoProductLinks = function GoProductLinks() {
  return _react2.default.createElement(
    'li',
    null,
    _react2.default.createElement(
      'a',
      { href: _go.CP_GO_URL_FAQ, target: '_blank', rel: 'noopener noreferrer' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'header.link.go.faq',
        defaultMessage: 'FAQ'
      })
    )
  );
};